import { toast } from "sonner";
import { ArrowRight } from "lucide-react";
import { MAYAR_CHECKOUT_URL } from "@/config/landing";

export const CTA_TEXT = "Pakai Kalkubisnis sekarang";

export function CtaButton({ testid, className = "", size = "lg", withIcon = true }) {
  const base =
    "inline-flex items-center justify-center gap-2 rounded-xl bg-teal-600 font-bold text-white shadow-lg shadow-teal-600/25 transition-[background-color,transform,box-shadow] duration-200 hover:bg-teal-700 hover:shadow-teal-600/40 hover:-translate-y-0.5 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-teal-600 active:translate-y-0";
  const sizes = {
    lg: "px-7 py-4 text-base",
    md: "px-5 py-3 text-sm",
  };
  const cls = `${base} ${sizes[size]} ${className}`;

  if (MAYAR_CHECKOUT_URL) {
    return (
      <a
        data-testid={testid}
        href={MAYAR_CHECKOUT_URL}
        target="_blank"
        rel="noopener noreferrer"
        className={cls}
      >
        {CTA_TEXT}
        {withIcon && <ArrowRight className="h-4 w-4" aria-hidden="true" />}
      </a>
    );
  }

  return (
    <button
      type="button"
      data-testid={testid}
      className={cls}
      onClick={() =>
        toast.info("Checkout belum aktif", {
          description:
            "URL pembayaran Mayar belum dipasang. Tambahkan di src/config/landing.js sebelum peluncuran.",
        })
      }
    >
      {CTA_TEXT}
      {withIcon && <ArrowRight className="h-4 w-4" aria-hidden="true" />}
    </button>
  );
}
